/* LTDM · Home - scroll reveal + count-up + interactions légères.
   Autonome (ne dépend PAS de ltdm-originale.js pour éviter les erreurs product-only). */
(function () {
  'use strict';

  /* ---- SCROLL REVEAL (IntersectionObserver + fail-safe) ---- */
  function initReveal() {
    var reveals = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');
    if (!reveals.length) return;
    function revealAll() { reveals.forEach(function (el) { el.classList.add('visible'); }); }
    if (!('IntersectionObserver' in window)) { revealAll(); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { obs.observe(el); });
    // fail-safe : rien ne doit rester invisible (SEO + capture)
    setTimeout(revealAll, 2500);
  }

  /* ---- COUNT-UP (chiffres animés .home-stat[data-count]) ---- */
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-count')) || 0;
    var suffix = el.getAttribute('data-suffix') || '';
    var dur = 1400, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = Math.round(target * eased);
      el.textContent = val + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function initCounts() {
    var stats = document.querySelectorAll('.home-stat[data-count]');
    if (!stats.length) return;
    if (!('IntersectionObserver' in window)) { stats.forEach(countUp); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { countUp(e.target); obs.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    stats.forEach(function (el) { obs.observe(el); });
  }

  function boot() { initReveal(); initCounts(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();


/* ============================================================
   JS DES SECTIONS (consolidé ici car Shopify n'injecte pas le
   {% javascript %} sur ce thème PageFly). Chargé via <script src>.
   ============================================================ */

/* ---- ltdm-home-blog.liquid ---- */
(function () {
  'use strict';

  document.querySelectorAll('[data-hbl-wrapper]').forEach(function (wrapper) {
    var rail    = wrapper.querySelector('[data-hbl-rail]');
    var btnPrev = wrapper.querySelector('[data-hbl-prev]');
    var btnNext = wrapper.querySelector('[data-hbl-next]');
    if (!rail) return;

    function getCards() { return Array.from(rail.querySelectorAll('.hbl-card')); }

    function getCardWidth() {
      var cards = getCards();
      if (cards.length === 0) return 0;
      var gap = parseInt(getComputedStyle(rail).gap, 10) || 0;
      return cards[0].offsetWidth + gap;
    }

    function updateNav() {
      if (!btnPrev || !btnNext) return;
      btnPrev.disabled = rail.scrollLeft <= 4;
      btnNext.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    }

    if (btnPrev) {
      btnPrev.addEventListener('click', function () {
        var step = getCardWidth();
        rail.scrollBy({ left: -step, behavior: 'smooth' });
      });
    }
    if (btnNext) {
      btnNext.addEventListener('click', function () {
        var step = getCardWidth();
        rail.scrollBy({ left: step, behavior: 'smooth' });
      });
    }

    rail.addEventListener('scroll', updateNav, { passive: true });

    // Initialisation
    updateNav();
    // Re-check after images load
    rail.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', updateNav, { once: true });
    });
  });
})();

/* ---- ltdm-home-calc-economies.liquid ---- */
(function () {
  function euro(n) { return n.toLocaleString('fr-FR') + ' €'; }
  function init(root) {
    if (root.__calceInit) return; root.__calceInit = true;
    var spend = root.querySelector('[data-calce-spend]');
    var freq = root.querySelector('[data-calce-freq]');
    var out = root.querySelector('[data-calce-out]');
    if (!spend || !freq || !out) return;
    var appl = parseFloat(root.getAttribute('data-appl')) || 349.99;
    var url = root.getAttribute('data-appl-url') || '';
    function render() {
      var m = Math.max(0, parseFloat(spend.value) || 0);
      var rate = parseFloat(freq.value) || 0.5;
      var yearly = Math.floor(m * 12 * rate);
      var monthlySave = yearly / 12;
      var payback = monthlySave > 0 ? Math.ceil(appl / monthlySave) : 0;
      var threeYear = yearly * 3;
      var html = '<p class="home-calce-save">Économie estimée / an</p>' +
        '<p class="home-calce-amount">≈ ' + yearly.toLocaleString('fr-FR') + ' <span>€/an</span></p>' +
        '<div class="home-calce-breakdown">';
      if (payback > 0 && payback <= 60) {
        html += '<div class="home-calce-bk"><b>~' + payback + ' mois</b><span>pour la rentabiliser</span></div>';
      }
      html += '<div class="home-calce-bk"><b>' + euro(threeYear) + '</b><span>sur 3 ans</span></div></div>';
      if (payback > 0 && payback <= 60) {
        html += '<p class="home-calce-payline">Rentabilisée en ~' + payback + ' mois, puis ' + euro(yearly) + ' économisés chaque année.</p>';
      }
      if (url) html += '<a class="btn-primary" href="' + url + '">Voir la litière recommandée</a>';
      out.innerHTML = html;
    }
    spend.addEventListener('input', render);
    freq.addEventListener('change', render);
    render();
  }
  document.querySelectorAll('[data-calce]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-calce]'); if (r) init(r); });
})();

/* ---- ltdm-home-calc-litieres.liquid ---- */
(function () {
  function init(root) {
    if (root.__calclInit) return; root.__calclInit = true;
    var input = root.querySelector('[data-calcl-input]');
    var out = root.querySelector('[data-calcl-out]');
    var minus = root.querySelector('[data-calcl-minus]');
    var plus = root.querySelector('[data-calcl-plus]');
    if (!input || !out || !minus || !plus) return;
    function render() {
      var cats = Math.max(1, Math.min(12, parseInt(input.value, 10) || 1));
      input.value = cats;
      var reco = Math.ceil(cats / 2);           // 1 litière auto pour 1-2 chats
      var manual = cats + 1;                     // règle vétérinaire classique en manuel
      /* autonomie dégressive (règle métier) : 1 litière = 14 j pour 1 chat → (litières × 14) ÷ chats, arrondi bas (pessimiste) */
      var days = Math.floor(reco * 14 / cats);
      var rhythm = days >= 12
        ? 'vous ne videz le tiroir que deux fois par mois environ'
        : (days >= 7 ? 'une vidange par semaine environ, zéro odeur entre-temps' : 'deux vidanges rapides par semaine, 30 secondes chacune');
      out.innerHTML =
        '<div class="home-calcl-big"><b>' + reco + '</b> litière' + (reco > 1 ? 's' : '') + ' automatique' + (reco > 1 ? 's' : '') + '</div>' +
        '<p class="home-calcl-sub">Pour ' + cats + ' chat' + (cats > 1 ? 's' : '') + ', une litière automatique se nettoie après chaque passage : elle reste propre en permanence. ' +
        'En litière classique, il en faudrait <b>' + manual + '</b> (règle « un bac par chat, plus un »).</p>' +
        '<p class="home-calcl-auto"><b>~' + days + ' jours d\u2019autonomie</b> entre deux vidanges du tiroir : ' + rhythm + '.</p>' +
        '<p class="home-calcl-note">Base : 1 litière automatique = 14 jours d\u2019autonomie pour 1 chat, à partager entre vos chats.</p>';
    }
    minus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) - 1; render(); });
    plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; render(); });
    input.addEventListener('input', render);
    render();
  }
  document.querySelectorAll('[data-calcl]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-calcl]'); if (r) init(r); });
})();

/* ---- ltdm-home-communaute.liquid ---- */
(function () {
  'use strict';

  var STEP_PX = 180;

  function initCommunauteCarousel(section) {
    var track   = section.querySelector('.ltdm-communaute__track');
    var btnPrev = section.querySelector('.ltdm-communaute__arrow--prev');
    var btnNext = section.querySelector('.ltdm-communaute__arrow--next');

    if (!track || !btnPrev || !btnNext) return;

    function updateArrows() {
      var atStart = track.scrollLeft <= 4;
      var atEnd   = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      btnPrev.disabled = atStart;
      btnNext.disabled = atEnd;
    }

    function scrollBy(delta) {
      track.scrollBy({ left: delta, behavior: 'smooth' });
    }

    btnPrev.addEventListener('click', function () { scrollBy(-STEP_PX); });
    btnNext.addEventListener('click', function () { scrollBy(STEP_PX); });
    track.addEventListener('scroll', updateArrows, { passive: true });

    updateArrows();
  }

  function init() {
    var sections = document.querySelectorAll('.ltdm-communaute');
    sections.forEach(function (s) {
      if (!s.__ltdmCommunauteInit) {
        s.__ltdmCommunauteInit = true;
        initCommunauteCarousel(s);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Rechargement Shopify Theme Editor */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.ltdm-communaute')) {
      e.target.__ltdmCommunauteInit = false;
      initCommunauteCarousel(e.target);
    }
  });
}());

/* ---- ltdm-home-faq.liquid ---- */
(function () {
  'use strict';
  function initFaqAccordion(root) {
    var details = root.querySelectorAll('.home-faq-details');
    if (!details.length) return;
    details.forEach(function (el) {
      el.addEventListener('toggle', function () {
        if (el.open) {
          details.forEach(function (other) {
            if (other !== el && other.open) other.removeAttribute('open');
          });
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.home-faq').forEach(initFaqAccordion);
    });
  } else {
    document.querySelectorAll('.home-faq').forEach(initFaqAccordion);
  }
})();

/* ---- ltdm-home-produits.liquid · ROULETTE 3D orbitale UNIFIEE (desktop + mobile) ----
   Meme moteur partout : orbite rAF, drag tactile/souris (swipe = rotation, relache = snap).
   Transform/opacity/filter/z-index via variables CSS --rlt-* (relayees en !important). */
(function () {
  var mqMobile = window.matchMedia('(max-width: 820px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var TAU = Math.PI * 2;

  function init(section) {
    if (section.__prodInit) return; section.__prodInit = true;
    var roulette = section.querySelector('[data-roulette]');
    if (!roulette) return;
    var cards = Array.prototype.slice.call(roulette.querySelectorAll('[data-roulette-card]'));
    var n = cards.length;
    if (!n) return;
    var dotsWrap = section.querySelector('[data-roulette-dots]');
    var delay = (parseInt(roulette.getAttribute('data-autoplay'), 10) || 0) * 1000;
    var step = TAU / n;

    /* decor + fleches crees en JS (markup Liquid inchange) */
    var ground = document.createElement('div');
    ground.className = 'home-prod-ground'; ground.setAttribute('aria-hidden', 'true');
    roulette.insertBefore(ground, roulette.firstChild);
    var halo = document.createElement('div');
    halo.className = 'home-prod-halo'; halo.setAttribute('aria-hidden', 'true');
    roulette.insertBefore(halo, roulette.firstChild);

    function mkNav(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'home-prod-nav home-prod-nav--' + (dir === 1 ? 'next' : 'prev');
      b.setAttribute('aria-label', dir === 1 ? 'Voir la litière suivante' : 'Voir la litière précédente');
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (dir === 1 ? 'm9 6 6 6-6 6' : 'm15 6-6 6 6 6') + '"/></svg>';
      b.addEventListener('click', function () { advance(dir); restart(); });
      roulette.appendChild(b);
    }
    mkNav(-1); mkNav(1);

    var frontIdx = 0;
    for (var i = 0; i < n; i++) { if (cards[i].classList.contains('is-featured')) { frontIdx = i; } }
    var target = -frontIdx * step;
    var angle = target;
    var raf = null, timer = null;
    var RX = 400, TILT = 24, SCMIN = 0.62;

    var dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      cards.forEach(function (_, i) {
        var d = document.createElement('button');
        d.className = 'home-prod-dot'; d.type = 'button';
        d.setAttribute('aria-label', 'Litière ' + (i + 1));
        d.addEventListener('click', function () { goTo(i); restart(); });
        dotsWrap.appendChild(d); dots.push(d);
      });
    }

    function cardW() { return cards[0].offsetWidth || 360; }

    function measure() {
      var w = roulette.clientWidth || 1100;
      if (mqMobile.matches) {
        RX = Math.max(110, w * 0.40);
        TILT = 16;
        SCMIN = 0.72;
        var maxH = 0;
        for (var i = 0; i < n; i++) { if (cards[i].offsetHeight > maxH) { maxH = cards[i].offsetHeight; } }
        if (maxH > 100) { roulette.style.height = (maxH + 18) + 'px'; }
      } else {
        RX = Math.min(430, Math.max(290, w * 0.38));
        TILT = 24;
        SCMIN = 0.62;
        roulette.style.height = '';
      }
    }

    function render() {
      for (var i = 0; i < n; i++) {
        var a = i * step + angle;
        var s = Math.sin(a);
        var depth = (Math.cos(a) + 1) / 2;      /* 1 = premier plan, 0 = fond */
        var x = s * RX;
        var sc = SCMIN + (1 - SCMIN) * depth;
        var blur = (1 - depth) * 1.8;
        var card = cards[i];
        card.style.setProperty('--rlt-tf',
          'translateX(-50%) translate3d(' + x.toFixed(1) + 'px,' + ((1 - depth) * -10).toFixed(1) + 'px,0) scale(' + sc.toFixed(3) + ') rotateY(' + (-s * TILT).toFixed(2) + 'deg)');
        card.style.setProperty('--rlt-op', (0.4 + 0.6 * depth).toFixed(3));
        card.style.setProperty('--rlt-fl', blur > 0.08 ? 'blur(' + blur.toFixed(2) + 'px)' : 'none');
        card.style.setProperty('--rlt-z', String(100 + Math.round(depth * 100)));
        card.setAttribute('data-pos', i === frontIdx ? 'center' : (x < 0 ? 'left' : 'right'));
        card.classList.toggle('is-front', i === frontIdx);
        card.setAttribute('aria-hidden', 'false');
      }
    }

    function tick() {
      var d = target - angle;
      if (Math.abs(d) < 0.0006) { angle = target; render(); raf = null; return; }
      angle += d * 0.09;
      render();
      raf = requestAnimationFrame(tick);
    }
    function kick() {
      if (reduce) { angle = target; render(); return; }
      if (!raf) { raf = requestAnimationFrame(tick); }
    }

    function shortest(d) { return Math.atan2(Math.sin(d), Math.cos(d)); }
    function goTo(i, dir) {
      var d = shortest(-i * step - target);
      if (dir === 1 && d > 1e-6) { d -= TAU; }   /* suivant = rotation negative */
      if (dir === -1 && d < -1e-6) { d += TAU; }
      target += d;
      frontIdx = i;
      dots.forEach(function (dd, k) { dd.classList.toggle('is-on', k === frontIdx); });
      kick();
    }
    function advance(dir) { goTo((frontIdx + dir + n) % n, dir); }

    function start() { if (delay > 0 && !reduce && !timer) { timer = setInterval(function () { advance(1); }, delay); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    /* ---- drag (swipe tactile + souris) : glisser = tourner, relacher = snap ---- */
    var dragging = false, dragMoved = false, dragX0 = 0, dragA0 = 0, dragT0 = 0;
    roulette.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.home-prod-nav') || e.target.closest('.home-prod-dot')) return;
      dragging = true; dragMoved = false;
      dragX0 = e.clientX; dragA0 = angle; dragT0 = Date.now();
      if (raf) { cancelAnimationFrame(raf); raf = null; }
      stop();
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - dragX0;
      if (Math.abs(dx) > 8) { dragMoved = true; }
      angle = dragA0 + dx * (step / (cardW() * 1.15));
      render();
    }, { passive: true });
    function dragEnd(e) {
      if (!dragging) return;
      dragging = false;
      var dx = (e.clientX || 0) - dragX0;
      var dt = Math.max(1, Date.now() - dragT0);
      var raw = -angle / step;
      var k = Math.round(raw);
      if (dragMoved && (Math.abs(dx) > cardW() * 0.16 || Math.abs(dx) / dt > 0.45)) {
        k = Math.round(raw + (dx < 0 ? 0.5 : -0.5));
      }
      target = -k * step;
      frontIdx = ((k % n) + n) % n;
      dots.forEach(function (dd, i) { dd.classList.toggle('is-on', i === frontIdx); });
      kick();
      start();
    }
    window.addEventListener('pointerup', dragEnd);
    window.addEventListener('pointercancel', dragEnd);

    cards.forEach(function (card, i) {
      card.addEventListener('click', function (e) {
        if (dragMoved) { e.preventDefault(); return; }        /* fin de swipe : pas de navigation */
        if (i !== frontIdx) { e.preventDefault(); goTo(i); restart(); }
      });
      card.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
    roulette.addEventListener('mouseenter', stop);
    roulette.addEventListener('mouseleave', function () { if (!dragging) { start(); } });
    roulette.addEventListener('focusin', stop);
    roulette.addEventListener('focusout', start);

    function refresh() { measure(); render(); }
    if (mqMobile.addEventListener) { mqMobile.addEventListener('change', refresh); }
    window.addEventListener('resize', refresh);
    window.addEventListener('load', refresh);

    measure(); render(); start();
    setTimeout(refresh, 400);   /* re-mesure apres chargement fonts/images */
  }
  document.querySelectorAll('.home-prod').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { var s = e.target.querySelector('.home-prod'); if (s) init(s); });
})();

/* ---- ltdm-home-transition.liquid · TIMELINE verticale animée au scroll ----
   Fil doré qui se dessine (--trans-p 0..1), médaillons/cartes qui s'allument à son passage. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(sec) {
    if (sec.__transInit) return; sec.__transInit = true;
    var steps = sec.querySelector('.ltdm-trans-steps');
    if (!steps) return;
    var items = Array.prototype.slice.call(steps.querySelectorAll('.ltdm-trans-step'));
    if (reduce) {
      steps.style.setProperty('--trans-p', '1');
      items.forEach(function (li) { li.classList.add('is-lit'); });
      return;
    }
    var ticking = false;
    function update() {
      ticking = false;
      var r = steps.getBoundingClientRect();
      if (r.height < 10) return;
      var p = (window.innerHeight * 0.72 - r.top) / r.height;   /* pointe du fil aux 72 % du viewport */
      p = Math.max(0, Math.min(1, p));
      steps.style.setProperty('--trans-p', p.toFixed(4));
      var tipY = r.top + r.height * p;
      items.forEach(function (li) {
        var lr = li.getBoundingClientRect();
        li.classList.toggle('is-lit', lr.top + 34 <= tipY);
      });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  document.querySelectorAll('.ltdm-transition').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { var s = e.target.querySelector('.ltdm-transition'); if (s) init(s); });
})();

/* ---- ltdm-home-app.liquid · bascule entre les 2 applis (Tuya / Neakasa) ---- */
(function () {
  function init(deck) {
    if (deck.__appInit) return; deck.__appInit = true;
    var tabs = Array.prototype.slice.call(deck.querySelectorAll('[data-app-tab]'));
    var phones = Array.prototype.slice.call(deck.querySelectorAll('[data-app-phone]'));
    function activate(i) {
      tabs.forEach(function (t, k) {
        t.classList.toggle('is-on', k === i);
        t.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
      phones.forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
    }
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { activate(i); }); });
    phones.forEach(function (p, i) {
      p.addEventListener('click', function () { if (!p.classList.contains('is-active')) { activate(i); } });
    });
  }
  document.querySelectorAll('[data-appdeck]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { var d = e.target.querySelector('[data-appdeck]'); if (d) init(d); });
})();

/* ---- ltdm-home-benefits.liquid · vague de retournement automatique au scroll ----
   À l'entrée de la section : chaque carte se retourne l'une après l'autre (aperçu de la
   face-complément), puis revient. Un clic utilisateur fige la carte (pas de re-flip auto). */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(sec) {
    if (sec.__bwave) return; sec.__bwave = true;
    if (reduce || !('IntersectionObserver' in window)) return;
    var cards = Array.prototype.slice.call(sec.querySelectorAll('.home-benefit-card.js-flip'));
    if (!cards.length) return;
    cards.forEach(function (c) { c.addEventListener('click', function () { c.__hold = true; }); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.disconnect();
        cards.forEach(function (c, i) {
          setTimeout(function () { if (!c.__hold) { c.classList.add('is-flipped'); } }, 600 + i * 280);
          setTimeout(function () { if (!c.__hold) { c.classList.remove('is-flipped'); } }, 600 + i * 280 + 2400);
        });
      });
    }, { threshold: 0.4 });
    io.observe(sec);
  }
  document.querySelectorAll('.home-benefits').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { var s = e.target.querySelector('.home-benefits'); if (s) init(s); });
})();

/* ---- ltdm-home-quiz.liquid ---- */
(function () {
  function initQuiz(root) {
    if (root.__quizInit) return; root.__quizInit = true;
    var steps = root.querySelectorAll('.home-quiz-step');
    var bar = root.querySelector('[data-quiz-bar]');
    var resultBox = root.querySelector('[data-quiz-result]');
    var slot = root.querySelector('[data-result-slot]');
    var restart = root.querySelector('[data-quiz-restart]');
    var dataEl = root.closest('.home-quiz').querySelector('[data-quiz-data]');
    var data = {}; try { data = JSON.parse(dataEl.textContent); } catch (e) {}
    var keys = ['petpivot', 'originale', 'neakasa'];
    var score = [0, 0, 0]; var cur = 0;

    function show(i) {
      steps.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      if (bar) bar.style.width = Math.round(((i + 1) / steps.length) * 100) + '%';
    }
    function finish() {
      var best = 0;
      for (var i = 1; i < 3; i++) { if (score[i] > score[best]) best = i; }
      var p = data[keys[best]] || {};
      // alt vide : image decorative, le titre du produit est adjacent (sinon lecture/copie en double)
      var img = p.img ? '<span class="home-quiz-resimg"><img src="' + p.img + '" width="120" height="120" alt="" loading="lazy"></span>' : '';
      var price = p.price ? '<span class="home-quiz-resprice">' + p.price + '</span>' : '';
      slot.innerHTML =
        '<div class="home-quiz-rescard">' + img +
        '<div class="home-quiz-resbody"><h3>' + (p.title || '') + '</h3><p>' + (p.reason || '') + '</p>' + price + '</div></div>' +
        (p.url ? '<a class="btn-primary" href="' + p.url + '">Découvrir ce modèle</a>' : '');
      steps.forEach(function (s) { s.classList.remove('is-active'); });
      if (bar) bar.style.width = '100%';
      resultBox.hidden = false;
    }
    root.querySelectorAll('.home-quiz-opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var w = (btn.getAttribute('data-w') || '0,0,0').split(',');
        for (var i = 0; i < 3; i++) { score[i] += parseInt(w[i], 10) || 0; }
        cur++;
        if (cur < steps.length) { show(cur); } else { finish(); }
      });
    });
    if (restart) restart.addEventListener('click', function () {
      score = [0, 0, 0]; cur = 0; resultBox.hidden = true; slot.innerHTML = ''; show(0);
    });
  }
  document.querySelectorAll('[data-quiz]').forEach(initQuiz);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-quiz]'); if (r) initQuiz(r);
  });
})();

/* ---- ltdm-home-veto.liquid ---- */
(function () {
  'use strict';

  var MOTION_OK = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initVetoCarousel(carousel) {
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('.ltdm-veto__slide'));
    var dots   = Array.prototype.slice.call(carousel.querySelectorAll('.ltdm-veto__dot'));
    var btnPrev = carousel.querySelector('.ltdm-veto__nav--prev');
    var btnNext = carousel.querySelector('.ltdm-veto__nav--next');

    if (slides.length < 2) return;

    var current = 0;
    var delay = parseInt(carousel.getAttribute('data-autoplay'), 10) || 5500;
    var timer = null;
    var startX = null;

    function goTo(idx) {
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }
      current = (idx + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-selected', 'true');
      }
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAuto() {
      if (!MOTION_OK) return;
      stopAuto();
      timer = setInterval(next, delay);
    }

    function stopAuto() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (btnNext) btnNext.addEventListener('click', function () { stopAuto(); next(); startAuto(); });
    if (btnPrev) btnPrev.addEventListener('click', function () { stopAuto(); prev(); startAuto(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stopAuto();
        goTo(parseInt(dot.getAttribute('data-index'), 10));
        startAuto();
      });
    });

    /* Swipe tactile */
    carousel.addEventListener('touchstart', function (e) {
      startX = e.changedTouches[0].clientX;
    }, { passive: true });

    carousel.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) {
        stopAuto();
        if (dx < 0) { next(); } else { prev(); }
        startAuto();
      }
      startX = null;
    }, { passive: true });

    /* Pause au survol */
    carousel.addEventListener('mouseenter', stopAuto);
    carousel.addEventListener('focusin',    stopAuto);
    carousel.addEventListener('mouseleave', startAuto);
    carousel.addEventListener('focusout',   function (e) {
      if (!carousel.contains(e.relatedTarget)) startAuto();
    });

    startAuto();
  }

  function init() {
    var carousels = document.querySelectorAll('.ltdm-veto__carousel');
    carousels.forEach(function (c) {
      if (!c.__ltdmVetoInit) {
        c.__ltdmVetoInit = true;
        initVetoCarousel(c);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Rechargement Shopify Theme Editor */
  document.addEventListener('shopify:section:load', function (e) {
    var carousel = e.target.querySelector('.ltdm-veto__carousel');
    if (carousel) {
      carousel.__ltdmVetoInit = false;
      initVetoCarousel(carousel);
    }
  });
}());

/* ---- ltdm-home-videos.liquid ---- */
(function () {
  'use strict';

  document.querySelectorAll('[data-hvd-stories]').forEach(function (dataEl) {
    var sectionId = dataEl.getAttribute('data-hvd-stories');
    var modal     = document.getElementById('hvd-modal-' + sectionId);
    if (!modal) return;

    var stories;
    try { stories = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(stories) || stories.length === 0) return;

    var currentIndex  = 0;
    var playerEl      = modal.querySelector('[data-hvd-player]');
    var infoEl        = modal.querySelector('[data-hvd-info]');
    var progressEl    = modal.querySelector('[data-hvd-progress]');
    var prevBtn       = modal.querySelector('[data-hvd-prev]');
    var nextBtn       = modal.querySelector('[data-hvd-next]');
    var closeBtn      = modal.querySelector('[data-hvd-close]');
    var overlay       = modal.querySelector('[data-hvd-overlay]');
    var lastFocused   = null;

    function buildEmbed(story) {
      var src = story.videoSrc || '';
      if (!src) return '<div style="display:flex;align-items:center;justify-content:center;height:100%;color:#fff;font-family:Poppins,sans-serif;font-size:.9rem;opacity:.6">Vidéo non configurée</div>';

      if (story.isShopifyVideo) {
        return '<video src="' + src + '" controls autoplay playsinline style="width:100%;height:100%"></video>';
      }

      // YouTube
      var ytMatch = src.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([A-Za-z0-9_-]{11})/);
      if (ytMatch) {
        return '<iframe src="https://www.youtube-nocookie.com/embed/' + ytMatch[1] + '?autoplay=1&rel=0" title="' + (story.title || 'Vidéo') + '" loading="lazy" allow="autoplay; encrypted-media; fullscreen" allowfullscreen width="560" height="315"></iframe>';
      }

      // Vimeo
      var vmMatch = src.match(/vimeo\.com\/(\d+)/);
      if (vmMatch) {
        return '<iframe src="https://player.vimeo.com/video/' + vmMatch[1] + '?autoplay=1" title="' + (story.title || 'Vidéo') + '" loading="lazy" allow="autoplay; fullscreen" allowfullscreen width="640" height="360"></iframe>';
      }

      // URL directe (mp4 etc.)
      return '<video src="' + src + '" controls autoplay playsinline style="width:100%;height:100%"></video>';
    }

    function updateNav() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex === stories.length - 1;
      if (progressEl) {
        progressEl.style.width = ((currentIndex + 1) / stories.length * 100) + '%';
      }
    }

    function load(index) {
      currentIndex = index;
      playerEl.innerHTML = buildEmbed(stories[index]);
      if (infoEl) infoEl.textContent = stories[index].title || '';
      updateNav();
    }

    function openModal(index) {
      lastFocused = document.activeElement;
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      load(index);
      closeBtn.focus();
    }

    function closeModal() {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      playerEl.innerHTML = '';
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    // Boutons story
    document.querySelectorAll('[data-hvd-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-hvd-open'), 10);
        openModal(isNaN(idx) ? 0 : idx);
      });
    });

    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', closeModal);
    prevBtn.addEventListener('click', function () { if (currentIndex > 0) load(currentIndex - 1); });
    nextBtn.addEventListener('click', function () { if (currentIndex < stories.length - 1) load(currentIndex + 1); });

    if (!window.__hvdKeyBound) {
      window.__hvdKeyBound = true;
      document.addEventListener('keydown', function (e) {
        var m = document.querySelector('[id^="hvd-modal-"]:not([hidden])');
        if (!m) return;
        if (e.key === 'Escape') { e.preventDefault(); var cb = m.querySelector('[data-hvd-close]'); if (cb) cb.click(); }
        if (e.key === 'ArrowLeft') { var pb = m.querySelector('[data-hvd-prev]'); if (pb && !pb.disabled) pb.click(); }
        if (e.key === 'ArrowRight') { var nb = m.querySelector('[data-hvd-next]'); if (nb && !nb.disabled) nb.click(); }
      });
    }
  });
})();

/* ---- Flip générique : .js-flip (clic / Entrée → retourne) ---- */
(function () {
  function bind(root) {
    (root || document).querySelectorAll('.js-flip').forEach(function (c) {
      if (c.__flipBound) return; c.__flipBound = true;
      function doFlip() {
        c.classList.toggle('is-flipped');
        var flipped = c.classList.contains('is-flipped');
        var fb = c.querySelector('.flip-back');
        var ff = c.querySelector('.flip-front');
        if (fb) fb.setAttribute('aria-hidden', flipped ? 'false' : 'true');
        if (ff) ff.setAttribute('aria-hidden', flipped ? 'true' : 'false');
      }
      c.addEventListener('click', doFlip);
      c.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); doFlip(); }
      });
    });
  }
  bind(document);
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
